<script lang="ts" setup>
  import { computed, ref } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useI18n } from 'vue-i18n'
  import { useUserStore } from '@/store/user'
  import { scheduleAutoTour } from '@/composables/useGuidedTour'
  import OnboardingTemplatesModal from '@/components/onboarding/OnboardingTemplatesModal.vue'

  const { t } = useI18n({ useScope: 'global' })
  const { aiEnabled } = storeToRefs(useUserStore())
  const welcomeTitleKey = computed(() =>
    aiEnabled.value ? 'welcome.ai.title' : 'welcome.title'
  )
  const welcomeTextKey = computed(() =>
    aiEnabled.value ? 'welcome.ai.text' : 'welcome.text'
  )

  const templatesOpen = ref(false)

  function openTemplates() {
    templatesOpen.value = true
  }

  function onTemplatesCompleted() {
    // WelcomeScreen va se démonter dès que les colonnes apparaissent.
    // On pose juste un drapeau ; DeckView, qui prend le relais, déclenchera
    // effectivement le tour une fois le DOM des colonnes prêt.
    scheduleAutoTour()
  }
</script>

<template>
  <div class="hero bg-base-200 h-screen overflow-y-auto">
    <div class="hero-content text-center">
      <div class="max-w-xl">
        <h1 class="text-5xl font-bold">{{ t(welcomeTitleKey) }}</h1>
        <p class="py-6">
          {{ t(welcomeTextKey) }}
        </p>
        <div class="flex flex-col gap-4 sm:flex-row sm:justify-center">
          <button
            class="btn btn-primary"
            @click="openTemplates"
          >
            {{ t('onboarding.templates.reopen') }}
          </button>
          <RouterLink
            v-if="aiEnabled"
            class="btn btn-primary"
            :to="{ name: 'ai-new', query: { 'prompt-id': 'briefing' } }"
          >
            {{ t('add-column.briefing') }}
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
  <OnboardingTemplatesModal
    v-model:open="templatesOpen"
    @completed="onTemplatesCompleted"
  />
</template>
